import React, { useEffect, useState, useRef, useCallback } from 'react';
import "@arcgis/core/assets/esri/themes/light/main.css";
import './esrimap.css';
import Search from '@arcgis/core/widgets/Search.js';
import InfoBar from '@components/common/InfoBars';
import { useDispatch, useSelector } from 'react-redux';
import { setMapManualAddress, setMapPincodeFirstTimeEdit } from '@store/actions/facilityGeoMapAction';
import { errorLogger } from '@utils/applicationLogUtils';
import config from '@config/config';

interface addressSearchProps {
  inputType?: string;
  selectedAddressValue?: any;
  labelName?: string;
  required?: any;
  disabled?: any;
  errorMessage?: any;
  formData?: any;
  formState?: any;
  objkey?: any;
  onSelectLocationChange?: any;
  onAddressChange?: any;
  mapRender?: any;
  setMapRender?: any;
  pageFlow?: any;
  polygonWork?: any;
  onSelectCoverageArea?: any;
  onCoverageAreaChange?: any;
};

export const HealthFacilitySearchMapPoc = ({ inputType = 'general', selectedAddressValue, labelName, required, disabled, errorMessage, formState, objkey, onSelectLocationChange, onAddressChange, mapRender, setMapRender, pageFlow, polygonWork, onSelectCoverageArea, onCoverageAreaChange }: addressSearchProps) => {
  const [suggestionAddressValue, setSuggestionAddressValue] = useState([]);
  const searchWidgetRef: any = useRef(null);
  const suggestionListRef: any = useRef(null);
  const dispatch = useDispatch();
  const facilityGeoMap = useSelector((state: any) => state.facilityGeoMap);
  const facilityGeoMapref = useRef(facilityGeoMap);
  useEffect(() => {
    facilityGeoMapref.current = facilityGeoMap;
  }, [facilityGeoMap]);

  const customSourceObj = {
    url: config.locateUrl,
    countryCode: 'IND',
    maxSuggestions: 30,
  };

  const initMapSearch = useCallback(() => {

    searchWidgetRef.current = new Search({
      container: selectedAddressValue.current,
      popupEnabled: false,
      resultGraphicEnabled: false,
      maxSuggestions: 30,
      includeDefaultSources: false,
      sources: [customSourceObj]
    })

    searchWidgetRef.current.on('select-result', (locateEvent: any) => {
      const { latitude, longitude } = locateEvent.result.feature.geometry;
      polygonWork ? onSelectCoverageArea({ address: selectedAddressValue.current.value, locationDetail: [longitude, latitude] }) : onSelectLocationChange({ latitude, longitude });
    });

    selectedAddressValue.current.value = !polygonWork ? formState[objkey].value ? formState[objkey].value : '' : '';
  }, []);

  useEffect(() => {
    initMapSearch();
  }, []);


  const handleChange = (e: any) => {
    e.preventDefault();
    const input = e.target.value;
    if (input.trim() && searchWidgetRef.current) {
      selectedAddressValue.current.value = input;
      !polygonWork ? onAddressChange() : onCoverageAreaChange();
      searchWidgetRef.current.suggest(input.trim()).then((suggestions: any) => {
        if (suggestions && suggestions.results[0].results.length > 0) {
          setSuggestionAddressValue(suggestions?.results[0]?.results);
        } else {
          setSuggestionAddressValue([])
        }
      });
      if (!facilityGeoMapref.current.mapServicesDown && !polygonWork) {
        dispatch(setMapManualAddress(true));
      }

    } else {
      selectedAddressValue.current.value = '';
      setSuggestionAddressValue([]);
      searchWidgetRef.current.clear();
      if (pageFlow == 'vhnd' && !polygonWork) {
        onSelectLocationChange({ latitude: '', longitude: '' });
        setMapRender(!mapRender);
      }
      !polygonWork ? onAddressChange() : onCoverageAreaChange();
      dispatch(setMapManualAddress(false));
    }
  };

  const selectSuggestion = async (suggestion: any, index: any) => {
    if (searchWidgetRef.current) {
      selectedAddressValue.current.value = suggestion.text;
      try {
        await searchWidgetRef.current.search(suggestion);
      } catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
      if (!facilityGeoMapref.current.mapServicesDown && !polygonWork) {
        setMapRender(!mapRender);
        dispatch(setMapManualAddress(false));
      }
      setSuggestionAddressValue([]);
      if (facilityGeoMapref.current.editFirstTimePincode && facilityGeoMapref.current.editFirstTimePincode.flow === 'edit' && !polygonWork) {
        dispatch(setMapPincodeFirstTimeEdit(
          {
            flow: 'edit',
            firstTime: false
          }
        ));
      } else {
        dispatch(setMapPincodeFirstTimeEdit(null));
      }
    }
  };

  const clearLocation = () => {
    selectedAddressValue.current.value = '';
    searchWidgetRef.current.clear();
    setSuggestionAddressValue([]);
    if (pageFlow == 'vhnd') {
      onSelectLocationChange({ latitude: '', longitude: '' });
      setMapRender(!mapRender);
    }
    onAddressChange();
    dispatch(setMapManualAddress(false));
  };

  const handleClickOutside = (event: any) => {
    if (suggestionListRef.current && !suggestionListRef.current.contains(event.target)) {
      setSuggestionAddressValue([]);
    }

  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.addEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (

    <div className='search-map-container'>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div className={`input-field-container`}>
          {labelName && (
            <label
              className={`label-name-from-parent ${required && 'yes'}`}
            >
              {labelName}
            </label>
          )}
          <input
            type='text'
            ref={selectedAddressValue}
            className={`input-field-address ${disabled ? 'disabled' : ''}`}
            placeholder='Search for Address or Pincode.'
            value={selectedAddressValue.current.value ? selectedAddressValue.current.value : ''}
            disabled={disabled}
            onChange={(e) => {
              handleChange(e);
            }}
          />
          <div className="input_field_infoBars">
            {inputType === 'success' ? (
              <InfoBar
                variant="success"
                message={errorMessage ? errorMessage : 'Success'}
                className="input_field_class"
              />
            ) : (
              ''
            )}
            {inputType === 'error' ? (
              <InfoBar
                variant="danger"
                message={errorMessage ? errorMessage : ''}
                className="input_field_class"
              />
            ) : (
              ''
            )}
          </div>
        </div>

        {(!disabled && !polygonWork) && <button
          className='clear-button'
          onClick={(e) => {
            e.preventDefault();
            clearLocation();
          }}
        >X</button>}
      </div>

      {suggestionAddressValue.length > 0 && (
        <div className='addressSuggestionContainer' ref={suggestionListRef}>
          <ul className='addressSuggestionList'>
            {suggestionAddressValue.map((suggestion: any, index: number) => (<li data-testid={`suggestion-text-${index}`} key={index} onClick={() => selectSuggestion(suggestion, index)}>
              {suggestion.text}
            </li>))}
          </ul>
        </div>
      )}
    </div>
  )
};

export default HealthFacilitySearchMapPoc;